<template>
  <gj-popover lazy placement="bottom" width="300" v-model="visible" @show="show">
    <div>显示在亚马逊前台的FBM数量</div>
    <el-form :model="form" ref="form" class="gj-form" label-width="100px" style="display: flex;
    flex-direction: column;
    align-items: flex-end;">
      <el-form-item
      style="margin-top:12px"
        prop="mfnQuantity"
        label="FBM库存数量"
        :rules="[{ required: true, validator: validateMfnQuantity }]"
      >
        <gj-input :width="inputWidth" v-model="form.mfnQuantity" placeholder="">
        </gj-input>
        <p style="line-height: 20px;" v-if="+form.mfnQuantity > +availableQuantity">当前库存数量大于自营仓可用量，可能会出现无法配送的情况</p>
      </el-form-item>
      <el-form-item prop="mfnFulfillmentLatency" label="FBM处理时间">
        <gj-input
          :width="inputWidth"
          v-model="form.mfnFulfillmentLatency"
          placeholder=""
          :rules="[{ required: true, message: '请输入FBM处理时间', trigger: 'blur' }]"
        >
          <template slot="append">天</template>
        </gj-input>
      </el-form-item>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="visible = false" style="border: 1px solid #1F6EEF;height:26px">取消</el-button>
        <el-button type="primary" size="mini" @click="confirm" v-loading="loading" style="height:26px">确定</el-button>
      </div>
    </el-form>
    <i class="el-icon-edit" slot="reference"></i>
  </gj-popover>
</template>

<script>
import { editGoodStorage } from '@/api/sale';
export default {
  name: 'edit-good-title',
  props: {
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      inputWidth: '200px',
      validateMfnQuantity: (rule, value, callback) => {
        if (!this.form.mfnQuantity) {
          callback(new Error('请输入FBM库存数量'));
        } else if (this.form.mfnQuantity > this.availableQuantity) {
          callback();
        } else {
          callback();
        }
      },
      availableQuantity: 0,
      visible: false,
      loading: false,
      form: {
        mfnFulfillmentLatency: this.row.mfnFulfillmentLatency,
        mfnQuantity: this.row.mfnQuantity,
      },
    };
  },
  methods: {
    show() {
      this.availableQuantity = this.row.availableQuantity;
      this.form = {
        mfnFulfillmentLatency: this.row.mfnFulfillmentLatency,
        mfnQuantity: this.row.mfnQuantity,
      };
    },
    // B08GKT75KG
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            listingId: this.row.id,
            mfnFulfillmentLatency: this.form.mfnFulfillmentLatency,
            mfnQuantity: this.form.mfnQuantity,
          };
          editGoodStorage(params)
            .then(() => {
              this.visible = false;
            })
            .complete(() => (this.loading = false));
        }
      });
    },
  },
};
</script>
